<template>
    <AppLayout
        path="clicks"
        :auth-api="api">
        <ClientSuspendedBanner
            v-if="showClientSuspendedBanner"
            class="default-layout-banner">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-html="suspendedBannerMsg" />
        </ClientSuspendedBanner>
        <router-view></router-view>
    </AppLayout>
</template>

<script>
import Vue from 'vue'
import { AppLayout } from '@technologyadvice/relay-frontend'
import { mapActions, mapGetters } from 'vuex'

import vueMoment from 'vue-moment'
import api from '@api/auth'
import axios from '@axios'
import ClientSuspendedBanner from '@components/ClientSuspendedBanner.vue'

Vue.use(vueMoment)

export default {
    components: {
        AppLayout,
        ClientSuspendedBanner,
    },
    data() {
        return {
            api,
            bannerRoutes: [
                'admin-review-creatives-edit-uuid',
                'admin-review-products-edit-uuid',
                'admin-user-reviews-edit-uuid',
                'CampaignInformation',
                'creatives-edit-uuid',
                'EditProductCategories',
                'EditProductFeatures',
                'EditProductMedia',
                'ProductBasicInfo',
                'product-reviews',
                'product-reviews-view-uuid',
                'ProductTrendsInsights',
                'trends',
            ],
            clientOnlySuspendedRoutes: [
                'creatives',
                'products',
                'products-create',
                'programs',
                'programs-create',
            ],
        }
    },
    computed: {
        ...mapGetters('clients', [ 'client' ]),
        ...mapGetters('auth', [ 'user' ]),
        showClientSuspendedBanner() {
            return this.client.is_suspended
                && this.suspendedBannerRoutes.includes(this.$route.name)
        },
        suspendedBannerMsg() {
            if (this.user.is_internal) {
                return 'This client is in a suspended state'
            }

            if (this.$route?.name?.toLocaleLowerCase().includes('product')) {
                return `Your account has been suspended. Your product will still appear on our sites,
                        but ads associated with your Intent Clicks campaign will not.<br>
                        Please contact your Sales Representative or Client Success Manager for assistance.`
            }

            return `Your account has been suspended so your ads will not appear on our sites.
                    Please contact your Sales Representative or Client Success Manager for assistance.`
        },
        suspendedBannerRoutes() {
            if (!this.user.is_internal) {
                return this.bannerRoutes.concat(this.clientOnlySuspendedRoutes)
            }
            return this.bannerRoutes
        },
    },
    async created() {
        if (this.user.client_uuid) {
            this.getClient({ uuid: this.user.client_uuid })
        }
        if (this.user.account_uuid && !this.user.is_internal) {
            await this.getAccountPlan(this.user.account_uuid)
        }
        const { data } = await axios.get('/config/ads').then(resp => resp.data)
        this.$store.state.config = { ...this.$store.state.config, ...data }
    },
    methods: {
        ...mapActions('clients', [ 'getClient' ]),
        ...mapActions('auth', [ 'getAccountPlan' ]),
    },
}
</script>
